import { Button, Form, Input } from "antd";
import { Field, FormikProvider, useFormik } from "formik";
import classNames from "classnames";
import ReversedRadiusDivider from "components/common/ReversedRadiusDivider";
import {
  useGetMagHomeSeo,
  useUpdateMagHomeSeo,
} from "pages/mag-home-management/api";

import styles from "./index.module.scss";
const SeoTab = () => {
  const { data } = useGetMagHomeSeo();
  const { mutate, isPending } = useUpdateMagHomeSeo();

  const [form] = Form.useForm();
  const formik = useFormik({
    initialValues: {
      tags: (data?.tags ?? []).join(","),
      keyWords: (data?.keyWords ?? []).join(","),
      description: data?.description ?? "",
      url: data?.url ?? "",
    },
    enableReinitialize: true,
    onSubmit: (values) => mutate(values),
  });
  const { setFieldValue, values, submitForm, resetForm } = formik;

  return (
    <div className={styles.home_seo_container}>
      <ReversedRadiusDivider />
      <div className={styles.home_seo_card}>
        <h3>سئوی صفحه اصلی</h3>
        <FormikProvider value={formik}>
          <Form className={styles.seo_form} form={form}>
            <Form.Item
              name="url"
              label="لینک"
              labelCol={{ span: 3 }}
              labelAlign="left"
              wrapperCol={{ span: 22 }}
            >
              <Field name="url">
                {({ field }) => (
                  <Input
                    {...field}
                    placeholder="لطفا بنویسید"
                    className={classNames(styles.common_textarea, ["dir-ltr"])}
                    value={values.url}
                    onChange={(e) => setFieldValue("url", e.target.value)}
                  />
                )}
              </Field>
            </Form.Item>
            <Form.Item
              name="description"
              label="توضیحات متا"
              labelCol={{ span: 3 }}
              labelAlign="left"
              wrapperCol={{ span: 22 }}
            >
              <Field name="description">
                {({ field }) => (
                  <Input.TextArea
                    {...field}
                    placeholder="لطفا بنویسید"
                    autoSize={{ minRows: 5, maxRows: 7 }}
                    className={styles.common_textarea}
                    value={values.description}
                    onChange={(e) =>
                      setFieldValue("description", e.target.value)
                    }
                  />
                )}
              </Field>
            </Form.Item>
            <Form.Item
              name="keyWords"
              label="کلیدواژه ها"
              labelCol={{ span: 3 }}
              labelAlign="left"
              wrapperCol={{ span: 22 }}
            >
              <Field name="keyWords">
                {({ field }) => (
                  <Input.TextArea
                    {...field}
                    placeholder="کلیدواژه ها را با ، جدا کنید (برای نمونه: کلید اول ، کلید دوم ، ...)"
                    autoSize={{ minRows: 5, maxRows: 7 }}
                    className={styles.common_textarea}
                    value={values.keyWords}
                    onChange={(e) => setFieldValue("keyWords", e.target.value)}
                  />
                )}
              </Field>
            </Form.Item>
            <Form.Item
              name="tags"
              label="متاتایتل ها"
              labelCol={{ span: 3 }}
              labelAlign="left"
              wrapperCol={{ span: 22 }}
            >
              <Field name="tags">
                {({ field }) => (
                  <Input.TextArea
                    {...field}
                    placeholder="متاتایتل ها را با ، جدا کنید (برای نمونه: کلید اول ، کلید دوم ، ...)"
                    autoSize={{ minRows: 5, maxRows: 7 }}
                    className={styles.common_textarea}
                    value={values.tags}
                    onChange={(e) => setFieldValue("tags", e.target.value)}
                  />
                )}
              </Field>
            </Form.Item>
          </Form>
        </FormikProvider>
      </div>
      <div className={styles.action_footer}>
        <Button onClick={() => resetForm()}>لغو کردن</Button>
        <Button type="primary" onClick={() => submitForm()} loading={isPending}>
          ذخیره تغییرات
        </Button>
      </div>
    </div>
  );
};

export default SeoTab;
